import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const ChainIcon = ({
  width = 24,
  height = 24,
  stroke = '#52575C',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    stroke={stroke}
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M10 13c.43.574.977 1.05 1.607 1.393.629.344 1.325.548 2.04.6.715.05 1.433-.053 2.104-.303.672-.25 1.282-.643 1.789-1.15l3-3c.91-.943 1.415-2.206 1.403-3.517-.011-1.311-.537-2.565-1.464-3.492-.927-.927-2.181-1.453-3.492-1.464-1.311-.012-2.574.492-3.517 1.403l-1.72 1.71"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M13.998 11.001c-.43-.574-.977-1.049-1.606-1.393-.63-.344-1.325-.548-2.04-.6-.716-.05-1.433.053-2.105.303-.672.251-1.282.643-1.789 1.15l-3 3c-.91.943-1.415 2.206-1.403 3.517.011 1.311.537 2.565 1.464 3.492.927.927 2.181 1.453 3.492 1.465 1.311.011 2.574-.493 3.517-1.404l1.71-1.71"
    />
  </svg>
);
